module.exports = __webpack_public_path__ + "2cc604c7d1e92ecfb05cd13260a2d274.pdf";